// import { createRouter, createWebHistory } from 'vue-router/dist/vue-router.esm-bundler'

import Home from '../views/new/HomePage.vue'
import { createRouter, createWebHistory } from 'vue-router'
const router = createRouter({
  history: createWebHistory(),
  routes: [
    {
      path: '/',
      name: 'Home',
      component: Home,
    },
    {
      path: '/all',
      name: 'AllPrivileges',
      component: () => import('../views/new/AllPrivileges.vue'),
      props: (route) => ({ query: route.query.text }),
    },
    {
      path: '/admin/dashboard',
      name: 'AdminPage',
      component: () => import('../views/new/AdminPageNew.vue'),
      // props: route => ({ query: route.query.action })
    },
    {
      path: '/admin/add-privilege',
      name: 'AddPrivilege',
      component: () => import('@/views/AddPrivilege1.vue'),
    },
    {
      path: '/admin/edit-privilege/:id',
      name: 'EditPrivilege',
      component: () => import('@/views/EditPrivilege1.vue'),
    },
  ],
})
export default router
